<template>
    <card-seplag class="">

        <!--  <div class="p-d-flex p-col-12" style="text-align:right"  v-if="ciclopessoa && ciclopessoa.length > 0  && ciclopessoa[0].possuiAlgumVinculoValidado">
            <Button type="Button" icon="pi pi-print" @click="impressao()" class="p-mr-2" label="Imprimir" v-tooltip="'Imprimir Protocolo'" style="width:130px" />    
        </div> -->
        <div class="p-col-12 p-align-center p-justify-center" style="text-align:center"
            v-if="ciclopessoa && ciclopessoa.length > 0">
            <img src="@/assets/LOGO_ESTADO_-_AZUL_VAZADO_NOVO.svg" class="img-logo-estado"
                alt="GOVERNO DO ESTADO DE MATO GROSSO">
            <br>
            <br>
            <label style="fontSize: 3.1rem; color:#193282; font-family: Uni-Neue-seplag;">{{
                ciclopessoa[0].ciclo.descCiclo }}</label>
            <br>
            <label style="fontSize: 1rem; color:#15629f; font-weight: bold;">Os dados apresentados no
                {{ ciclopessoa[0].ciclo.descCiclo }} são originados do SEAP ou Recadastramento anterior</label>
            <br>
            <h3 class="texto-recadastramento"><strong> {{ ciclopessoa[0].ciclo.dataInicioExtenso }} até
                    {{ ciclopessoa[0].ciclo.dataFinalExtenso }} </strong></h3>
            <br>
            <br>
            <!-- <span :class="'product-badge status-'+vinc.statusCicloPessoa">{{vinc.statusCicloPessoa}}</span><br><br>  -->
            <Button icon="pi pi-list" label="Iniciar" style="min-width: 200px; width: auto;"
                class="p-button-primary p-button-rounded" @click="getDadosPessoa()"
                v-if="ciclopessoa[0].ciclo.statCiclo == 'ABERTO' && !contadorDeVinculos()" />
            <h3 v-if="ciclopessoa[0].ciclo.statCiclo != 'ABERTO'"> Recadastramento Fechado </h3>
        </div>
        <!--Renderizado se não existe um ciclo anterior vigente, ou a pessoa não faz parte do publico alvo  -->
        <div class="p-col-12 p-align-center p-justify-center" style="text-align:center" v-if="!ciclopessoa">
            <img src="@/assets/LOGO_ESTADO_-_AZUL_VAZADO_NOVO.svg" class="img-logo-estado"
                alt="GOVERNO DO ESTADO DE MATO GROSSO">
            <label style="fontSize: 1rem; color:#15629f; font-weight: bold;">Os dados apresentados no Recadastramento
                são originados do SEAP ou Recadastramento anterior</label>
            <!-- <span :class="'product-badge status-'+vinc.statusCicloPessoa">{{vinc.statusCicloPessoa}}</span><br><br>  -->
            <!-- <h3> Recadastramento Fechado </h3> -->
        </div>
        <hr class="p-col-12 hr-modal border-none">
        <div class="p-col-12 only-print" v-if="ciclopessoa && ciclopessoa.length > 0">
            <Card>
                <template slot="content">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <h4>Por Favor Ultilize o Botão Imprimir para Imprimir esse documento</h4>
                        </div>
                    </div>

                </template>
            </Card>
        </div>
        <hr class="p-col-12 hr-modal border-none"
            v-if="ciclopessoa && ciclopessoa.length > 0 && ciclopessoa[0].possuiAlgumVinculoValidado">
        <div class="p-col-12 alinhamento "
            v-if="ciclopessoa && ciclopessoa.length > 0 && ciclopessoa[0].possuiAlgumVinculoValidado">
            <div class="p-grid">


                <div class="p-col-12 texto-centro alinhamento border-y" style="margin: 1rem 0px"
                    v-if="ciclopessoa && ciclopessoa.length > 0 && ciclopessoa.length < 2 && ciclopessoa[0].possuiAlgumVinculoValidado">
                    <h3>COMPROVANTE DE REGULARIZAÇÃO DO RECADASTRAMENTO</h3>
                </div>

                <div class="p-col-12 texto-centro alinhamento border-y" style="margin: 1rem 0px"
                    v-if="ciclopessoa && ciclopessoa.length > 0 && ciclopessoa.length > 1 && ciclopessoa[0].possuiAlgumVinculoValidado">
                    <h3>COMPROVANTES DE REGULARIZAÇÃO DO RECADASTRAMENTO</h3>
                </div>
                <div class="p-col-12 p-grid"
                    style="display: flex; flex-direction: column; align-items: center;    justify-content: center; ">

                    <Card style="width: 80%;">
                        <template slot="content">

                            <div class="p-col-12 texto-centro alinhamento border-y" style="margin-bottom: 1rem">
                                <h3>DADOS DO FUNCIONÁRIO</h3>
                            </div>
                            <div class="p-grid card-custom">

                                <div class="p-col-12">
                                    <strong>Matrícula: </strong> {{ ciclopessoa[0].vinculosAtivos[0].numrMatricula }}
                                </div>

                                <div class="p-col-12 ">
                                    <strong>Nome: </strong>{{ ciclopessoa[0].vinculosAtivos[0].nomePessoa }}
                                </div>


                                <div class="p-col-12" style="word-break: break-all;">
                                    <strong>Data de Inicio do Recadastramento: </strong>
                                    {{ ciclopessoa[0].dataInicioRecadastramentoExtenso }}
                                </div>

                                <div class="p-col-12">
                                    <!--<strong>Testes a serem exculidos</strong>
                                     protocolo: {{ciclopessoa[0].vinculosAtivos[0].numrProtocolo}} <p/> 
                                     IdenPessoa: {{ciclopessoa[0].vinculosAtivos[0].idenPessoa}} <p/> 
                                    -->

                                </div>
                            </div>
                        </template>
                    </Card>
                </div>


                <div class="p-col-12 p-grid"
                    style="display: flex; flex-direction: column; align-items: center;    justify-content: center; row-gap: ;">

                    <div class="p-col-10 p-grid" style="padding: 2rem"
                        v-for="vinculo in this.ciclopessoa[0].vinculosAtivos" :key="vinculo.idenVinculoCiclo">


                        <Card style="width: 100%;" v-if="vinculo.statVinculoCiclo != 'INATIVO'">
                            <!-- v-bind:class="[vinculo.numrProtocolo ? 'concluido': 'pendente']" -->
                            <template slot="content">
                                <div class="p-grid card-custom">
                                    <!--
                                    <div class="p-col-12 texto-centro alinhamento border-y" style="margin-bottom: 1rem">
                                        <h3>DADOS DO FUNCIONÁRIO</h3>
                                    </div> 
                                    <div class="p-col-12">
                                    <strong>Matrícula: </strong> {{vinculo.numrMatricula}}
                                    </div>

                                    <div class="p-col-12 ">
                                    <strong>Nome: </strong>{{vinculo.nomePessoa}}
                                    </div>                               
                                    
                                    <div class="p-col-12" style="word-break: break-all;margin-bottom:1rem">
                                        <strong>Data de Inicio do Recadastramento: </strong>  {{ciclopessoa[0].dataInicioRecadastramentoExtenso}}
                                    </div>
-->
                                    <div class="p-col-12 texto-centro titulo-card-protocolo"
                                        v-if="vinculo.flagEmpregadoPublico == 'N'">

                                        <div class="p-col-12 texto-centro alinhamento border-y"
                                            style="margin-bottom: 1rem">
                                            <h3 v-if="vinculo.vinculo && vinculo.vinculo.cargo"> <strong>VÍNCULO
                                                    {{ vinculo.numeroVinculo + " - "+vinculo.vinculo.cargo.descSeap}}</strong></h3>
                                            <h3 v-else> <strong>VÍNCULO {{ vinculo.numeroVinculo }}</strong></h3>
                                        </div>

                                    </div>

                                    <div class="p-col-12 texto-centro titulo-card-protocolo" v-else>
                                        <h4 v-if="vinculo.descUnidade"> <strong>VÍNCULO COM A EMPRESA
                                                {{ vinculo.descUnidade }}</strong></h4>
                                    </div>

                                    <div class="p-col-12" style="word-break: break-all;">
                                        <strong>Órgão: </strong> {{ vinculo.vinculo && vinculo.vinculo.orgao ?
                                            vinculo.vinculo.orgao.siglOrgao : "Empresa Pública" }}
                                    </div>

                                    <div class="p-col-12" style="word-break: break-all;">
                                        <strong>Status: </strong> {{ vinculo.numrProtocolo ? "Concluído" : "Pendente" }}
                                    </div>

                                    <div class="p-col-12" style="word-break: break-all;" v-if="vinculo.numrProtocolo">
                                        <strong>Concluído em:</strong> {{ vinculo.dataProtocoloExtenso }}
                                    </div>

                                    <div class="p-col-12" style="word-break: break-all;" v-if="vinculo.numrProtocolo">
                                        <strong>Data de emissão:</strong> {{ dataImpressao }}
                                    </div>

                                    <div class="p-col-12 " style="word-break: break-all;" v-if="vinculo.numrProtocolo">
                                        <strong>Nº Protocolo: </strong> <span class="protocolo">{{ vinculo.numrProtocolo
                                            }}</span>
                                    </div>
                                    <!-- <strong>Nº Protocolo:  </strong> <span class="protocolo">{{vinculo.numrProtocolo}}</span> -->

                                    <!-- <hr class="p-col-12 hr-modal">
                                    <div class="p-col-12">
                                        <div class="p-grid">
                                            <div class="p-col-12 p-md-3">
                                                <Button label="Visualizar" class="p-button-warning" />
                                            </div>
                                        </div>
                                    </div> -->
                                </div>

                            </template>
                            <template #footer>
                                <!-- <div style="display: flex;justify-content: center">
                                    <Button 
                                        type="Button" 
                                        icon="pi pi-print" 
                                        @click="impressao(vinculo.numrProtocolo)" 
                                        class="p-mr-2" 
                                        label="Imprimir" 
                                        v-tooltip="'Imprimir Protocolo'" 
                                        style="width:130px"
                                        :disabled ="!vinculo.numrProtocolo"
                                    />    
                                  </div>-->
                            </template>

                        </Card>

                    </div>
                    <div style="display: flex; align-items: center;">
                        <div>
                            <div class="p-d-flex p-col-12" style="text-align:right"
                                v-if="ciclopessoa && ciclopessoa.length > 0 && ciclopessoa[0].possuiAlgumVinculoValidado">
                                <Button type="Button" icon="pi pi-print"
                                    @click="impressao(ciclopessoa[0].vinculosAtivos[0].idenPessoa)" class="p-mr-2"
                                    label="Imprimir" v-tooltip="'Imprimir Protocolo'" style="width:230px"
                                    :disabled="!ciclopessoa[0].vinculosAtivos[0].idenPessoa" />
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </div>
        <Dialog :visible.sync="exibirDialogoMTSaude" :style="{ width: '35vw', background: 'red' }"
            class="p-dialog-mtsaude" :modal="true">
            <template #header>
                <img src="@/assets/logo-mtsaude.png" class="img-logo-mtsaude" alt="MT Saúde">
            </template>
            <div class="confirmation-content">
                <!--<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: red;" />
                <span>Você tem certeza que deseja <strong>EXCLUIR</strong> o vínculo ?</span>-->

                <span>
                    <ol>
                        <span>Para quem busca saúde, cuidado e bem-estar com valores acessíveis, o MT Saúde é a escolha
                            perfeita. Conheça as 5 principais vantagens em contratar o MT Saúde como plano:</span>
                        <li class="listaNumerada">Melhor custo-benefício do mercado (planos a partir de R$ 115,40)*;
                        </li>
                        <li class="listaNumerada">Amplo rol de procedimentos médicos;</li>
                        <li class="listaNumerada">Portabilidade com carência zero;</li>
                        <li class="listaNumerada">Mais de 450 prestadores de serviços de saúde;</li>
                        <li class="listaNumerada">Retorne ao plano sem carência para exames e consultas.</li>
                    </ol>
                </span>
            </div>
            <template #footer>
                <p style="text-align:justify"><i class="pi pi-check" style="font-size: 1rem; color: green;" /> Garanta
                    mais tranquilidade e segurança para você e sua família ao contar com um plano completo de
                    assistência à saúde do servidor.</p>
                <p>&nbsp;</p>
                <p style="text-align:justify"><i class="pi pi-check" style="font-size: 1rem; color: green;" /> Saiba
                    mais: fale com a nossa Central de Atendimento: <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;WhatsApp (65)
                    98463-3773 (<a href="https://wa.me/5565984633773" target="_Blank">clique aqui</a>)
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ou acesse o site <a href="https://www.matogrossosaude.mt.gov.br"
                        target="_Blank">https://www.matogrossosaude.mt.gov.br/</a>
                </p>
            </template>
        </Dialog>

        <Dialog :header.sync="tituloTermo" :visible.sync="dialogNaoConcordo" class="dialogo-termo-aceite"
            :contentStyle="{ width: '50vw' }" :modal="true">
            <div class="confirmation-content text-center">
                <div v-html="textoDialogo" />
            </div>
            <template #footer>
                <Button label="Fechar" icon="pi pi-times" @click="fecharDialogo"
                    class="p-button-text p-button-danger" />
                <Button label="Aceitar" icon="pi pi-check" @click="aceitoTermo()" class="p-button-text p-button-success"
                    autofocus />
            </template>

        </Dialog>

        <ExibirPDF v-if="pdfBase64" v-model="exibirPDFDocumento" :tamanhoTela="'70.vw'" :alturaTela="'50.vw'"
            :tituloTela="nomeModalPDF" :pdfElement="pdfBase64" />
    </card-seplag>

</template>
<script>
// import Rotulo from '@/template/RotuloSeplag.vue'
import CardSeplag from '@/template/CardSeplag.vue'
import ExibirPDF from '@/template/CardExibirPDF.vue'
import { baseApiUrl } from '@/config/global'
import moment from 'moment'
import { printToast } from '../config/global'
const delay = (delayInms) => {
    return new Promise(resolve => setTimeout(resolve, delayInms));
}
export default {
    name: 'dashBoard',
    components: { CardSeplag, ExibirPDF },
    data: function () {
        return {
            msgUsuario: this.$store.getters.getMsgUsuario,
            ciclopessoa: this.$store.getters.getCicloPessoa,
            home: { label: "Dados Pessoais", to: '/' },
            items: [
                /*{label:"Dados Pessoais"},*/
                { label: "Documentos", color: "red" },
                { label: "Endereço", color: "green" },
                { label: "Formação Acadêmica" },
                { label: "Capacitação" },
                { label: "Experiência Profissional" },
                { label: "Dependentes" },
                { label: "Questionário Bem-Estar" },
                { label: "Vínculos" }
            ], //moment(this.$store.getters.getCicloPessoa[0].ciclo.dataInicio,'dd/mm/yyyy').toDate()
            dialogNaoConcordo: false,
            textoDialogo: "<p>Você não poderá começar o recadastramento sem concordar com o termo listado!</p>",
            tituloTermo: "Termo de Aceite Lei Geral de Proteção de Dados Pessoais",
            visaoEmpressao: false,
            dataImpressao: moment().locale('pt-br').format('LLL'),
            dataInicioClico: null,
            dataFimClico: null,
            exibirPDFDocumento: false,
            pdfBase64: "",
            exibirDialogoMTSaude: false,
            nomeModalPDF: "MODAL PDF",
            isEmpregadoPublico: false
        }
    },
    methods: {
        contadorDeVinculos() {
            let total = 0
            this.ciclopessoa[0].vinculosAtivos.map((vinculo) => {
                if (vinculo.statVinculoCiclo != "INATIVO") {
                    total++
                }
            })
            let count = 0
            this.ciclopessoa[0].vinculosAtivos.map((vinculo) => {
                if (vinculo.numrProtocolo && vinculo.statVinculoCiclo != "INATIVO") {
                    count++
                }
            })
            if (total == count) {
                return true
            }

            return false
        },

        async carregarDados() {

            if (this.ciclopessoa && this.ciclopessoa.length > 0) {
                this.dataInicioClico = moment(this.ciclopessoa[0].ciclo.dataInicio, 'DD/MM/YYYY').locale('pt-br').format('LL')
                this.dataFimClico = moment(this.ciclopessoa[0].ciclo.dataFinal, 'DD/MM/YYYY').locale('pt-br').format('LL')
            }
            if (this.msgUsuario && this.msgUsuario > 0) {
                printToast({
                    severity: 'info',
                    summary: this.msgUsuario,
                });

            }



            await delay(1000);
            this.exibirDialogoMTSaude = this.ciclopessoa && this.ciclopessoa[0].vinculosAtivos[0].numrProtocolo && this.ciclopessoa[0].vinculosAtivos[0].numrProtocolo.length > 0 ? true : false;



        },
        impressao() {
            let bodyRelatorio = {
                idenPessoa: this.ciclopessoa[0].vinculosAtivos[0].idenPessoa

            }
            this.$http.get(`${baseApiUrl}/relatorios/recadastroprotocolo/${this.ciclopessoa[0].idenCicloPessoa}`, JSON.stringify(bodyRelatorio)).then(res => {
                this.pdfBase64 = 'data:application/pdf;base64,' + res.data.dadosRelatorioBase64
                this.nomeModalPDF = "PROTOCOLO DO RECADASTRAMENTO"
                this.exibirPDFDocumento = true
            })

            // this.dataImpressao = moment().locale('pt-br').format('LLL')
            // window.print()
        },
       getDadosPessoa() {
             this.$http.get(`${baseApiUrl}/ciclopessoas/empregado-publico/${this.ciclopessoa[0].idenCicloPessoa}`).then(res => {
               this.isEmpregadoPublico = res.data;
             });
            this.$http.get(`${baseApiUrl}/ciclopessoas/${this.ciclopessoa[0].idenCicloPessoa}`).then(res => {
                this.$store.commit("setDadosPessoa", JSON.stringify(res.data))
                let flag = this.isEmpregadoPublico
                let etapaCliclo = res.data.fasesCicloPessoa.filter(function (etapa) {
                    if (etapa.fase.statFase != 'INATIVO' && etapa.fase.descFase != 'TERMO_ACEITE') {
                        if (etapa.fase.descFase == 'VINCULOS' && flag) {
                            return false
                        } else {
                            return true
                        }
                    } else {
                        return false
                    }
                })
                this.$store.commit("setEtapasCiclo", JSON.stringify(etapaCliclo))

                // // Listar Países
                this.$http.get(`${baseApiUrl}/paises/all`).then(res => {
                    let paises = res.data
                    this.$store.commit("setPais", paises)
                })

                // // Listar UF's
                this.$http.get(`${baseApiUrl}/ufs/all`).then(res => {
                    let ufs = res.data
                    this.$store.commit("setUf", ufs)
                })

                // // Listar Orgao Documentos
                this.$http.get(`${baseApiUrl}/orgaoDocumentos/ativosAll`).then(res => {
                    let orgaoDocumentos = res.data
                    this.$store.commit("setOrgaoDocumentos", orgaoDocumentos)

                })

                if (this.$store.getters.getDadosPessoa.flagTermoAceite == 'N') {
                    this.tituloTermo = this.$store.getters.getDadosPessoa.termo.descTermo
                    this.textoDialogo = this.$store.getters.getDadosPessoa.termo.infoTermo
                    this.dialogNaoConcordo = true
                } else {
                    this.$router.push({ name: 'RECAD_DADOS_PESSOAIS_VIEW' })
                }
            })
        },
        aceitoTermo() {
            this.$http.put(`${baseApiUrl}/ciclopessoas/termoaceite/${this.$store.getters.getCicloPessoa[0].idenCicloPessoa}`).then(dadosPessoa => {
                this.$store.commit("setDadosPessoa", JSON.stringify(dadosPessoa.data))
                this.$router.push({ name: "RECAD_DADOS_PESSOAIS_VIEW" })
            })
        },
        fecharDialogo() {
            this.dialogNaoConcordo = false;
        }
    },
    mounted() {
        this.carregarDados()
    },
    computed: {
        getCicloPessoa() {
            return this.$store.getters.getCicloPessoa
        }
    },
    watch: {
        getCicloPessoa(novoCicloPessoa) {
            this.ciclopessoa = novoCicloPessoa
            this.dataInicioClico = moment(this.ciclopessoa[0].ciclo.dataInicio, 'DD/MM/YYYY').locale('pt-br').format('LL')
            this.dataFimClico = moment(this.ciclopessoa[0].ciclo.dataFinal, 'DD/MM/YYYY').locale('pt-br').format('LL')
            // this.carregarDados()      
        }
    }
}

</script>

<style lang="scss" scoped>
.card-custom {
    min-width: auto;
    max-width: auto;
}

.p-dialog-mtsaude {
    background: rgb(68, 62, 62);
    width: 20px;

}

.d-flex-card {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.border-none {
    border: none !important;
}

.border-y {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.listaNumerada {
    list-style-type: decimal-leading-zero;
    margin-left: 3vw;
    margin: 6.5px 0px 6.5px 3vw;

}

.listaNumerada::marker {
    font-weight: bold;
    color: blue;
}

@media screen and (max-width: 767px) {
    .d-flex-card {
        flex-direction: column;
    }
}

.modal-monitora {
    width: 70rem;
    left: 28rem;
}

.hr-modal {
    border: 0;
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(148, 92, 92, 0.3);
}

.texto-recadastramento {
    font-family: Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif;
    color: rgb(96, 125, 139);
}

.texto-centro {
    text-align: center;
}

.img-logo-estado {
    width: 30%;
}

.titulo-card-protocolo {
    margin-bottom: 1vw;
}

.hr-visivel-sm {
    display: none;
}

.protocolo {
    font-size: 20px;
}

@media screen and (max-width: 40em) {
    .modal-monitora {
        width: 97% !important;
        left: 0;
    }

    .hr-visivel-sm {
        display: inline;
    }

    .img-logo-estado {
        width: 60%;
    }

    .calendarioCiclo {
        width: 90% !important;
        left: 18px !important;
    }

    body .p-treetable .p-treetable-thead>tr>th .sm-invisible {
        display: none !important;
    }

    .tamanho {
        width: 23% !important;
    }

    .dialogo-termo-aceite {
        width: 100% !important;
        height: 100% !important;
    }

    .p-dialog-content {
        width: 100% !important;
        word-wrap: break-word;
    }

    .p-datatable-responsive .p-datatable-thead>tr>th,
    .p-datatable-responsive .p-datatable-tfoot>tr>td {
        display: none !important;
    }

    .p-datatable-responsive .p-datatable-tbody>tr>td {
        text-align: left !important;
        display: block;
        border: 0 none;
        width: 100% !important;
        float: left;
        clear: left;
    }

    .p-datatable-responsive .p-datatable-tbody>tr>td .p-column-title {
        padding: .4em;
        min-width: 30%;
        display: inline-block;
        margin: -.4em 1em -.4em -.4em;
        font-weight: bold;
    }

    body .p-datatable .p-datatable-header {
        border-bottom: 1px solid #c8c8c8;
    }
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.product-badge.status-validado {
    background: #c8e6c9;
    color: #256029;
}

.product-badge.status-aguardando {
    background: #feedaf;
    color: #8a5340;
}

.product-badge.status-PENDENTE {
    background: #ffcdd2;
    color: #c63737;
}

.product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.concluido {
    border-top: 4px solid MediumSeaGreen;
}

.pendente {
    border-top: 4px solid DarkOrange;
}

ul>li {
    padding: 5px;
}
</style>
